import { useMemo } from 'react';
import type { AiSnapAnalysis } from './useAiSnapModel';

type Props = {
  open: boolean;
  itemIdx: number;
  analysis: AiSnapAnalysis | null;
  name: string;
  grams: number;
  nutrients: Record<string, number>;
  onClose: () => void;
  onChange: (next: { name?: string; grams?: number }) => void;
  onOpenWiki: (itemName: string) => void;
};

const fmt = (v: any, digits = 0) => {
  const n = Number(v);
  if (!Number.isFinite(n)) return '—';
  const p = Math.pow(10, digits);
  return String(Math.round(n * p) / p);
};

export function AiSnapItemEditorSheet(props: Props) {
  const { open, name, grams, nutrients } = props;

  const quick = [50, 100, 150, 200, 300];

  const macro = useMemo(() => {
    return {
      calories: nutrients.calories,
      protein: nutrients.protein,
      carbs: nutrients.carbs,
      fat: nutrients.fat,
    };
  }, [nutrients]);

  if (!open) return null;

  return (
    <div className="as-overlay" onClick={(e) => e.target === e.currentTarget && props.onClose()}>
      <div className="as-sheet as-editor">
        <div className="as-handle" />
        <div className="as-top">
          <button className="as-icon-btn" onClick={props.onClose} aria-label="返回">←</button>
          <div className="as-title">编辑菜品</div>
          <button className="as-icon-btn" onClick={() => props.onOpenWiki(name)} aria-label="百科">📖</button>
        </div>

        <div className="as-content">
          <div className="as-field">
            <div className="as-label">名称</div>
            <input
              className="as-input"
              value={name}
              onChange={(e) => props.onChange({ name: e.target.value })}
              placeholder="请输入菜品名称"
            />
          </div>

          <div className="as-field">
            <div className="as-label">克重</div>
            <div className="as-stepper">
              <button className="as-step" onClick={() => props.onChange({ grams: Math.max(1, grams - 10) })}>-</button>
              <div className="as-step-val">{fmt(grams, 0)} g</div>
              <button className="as-step" onClick={() => props.onChange({ grams: grams + 10 })}>+</button>
            </div>
            <div className="as-quick">
              {quick.map((g) => (
                <button key={g} className={`as-chip ${g === Math.round(grams) ? 'active' : ''}`} onClick={() => props.onChange({ grams: g })}>
                  {g}g
                </button>
              ))}
            </div>
          </div>

          <div className="as-card">
            <div className="as-card-title">随克重变化的营养（估算）</div>
            <div className="as-macro-grid">
              <div className="as-macro"><span>热量</span><b>{fmt(macro.calories, 0)}</b><i>kcal</i></div>
              <div className="as-macro"><span>蛋白</span><b>{fmt(macro.protein, 1)}</b><i>g</i></div>
              <div className="as-macro"><span>碳水</span><b>{fmt(macro.carbs, 1)}</b><i>g</i></div>
              <div className="as-macro"><span>脂肪</span><b>{fmt(macro.fat, 1)}</b><i>g</i></div>
            </div>
          </div>

          <div style={{ height: 12 }} />
        </div>
      </div>
    </div>
  );
}
